const AppUtils = {
  // pattern for version starts with prefix 'WallabyVersion = '
  // and continues until first occurrence of '<' or any whitespace
  VERSION_SEARCH_PATTERN: /(?:WallabyVersion = )([^< \t\n]*)(?:[< \t\n])/,

  getVersion(appIndexFile: string) {
    const regexp = new RegExp(AppUtils.VERSION_SEARCH_PATTERN, 'g');
    return regexp.exec(appIndexFile)[1];
  },
};

export default AppUtils;
